// extracted by mini-css-extract-plugin
module.exports = {"body":"SignIn_body__3Or97","forgot_pwd":"SignIn_forgot_pwd__awye_","footer":"SignIn_footer__3cJHj"};